export interface EarnCode {
  bNonWorkingHours: boolean;
  bNonWorkingHrs: boolean;
  billStatus: string;
  descShort: string;
  description: string;
  earnCodeID: string;
  earnCodeType: string;
  factor: number;
  notes: string;
  payFactor: number;
  parentEC?: string;
  bParent?: boolean;
  ruleDescription: string;

  // client
  text: string;
  value: string;
}
